export type PartnershipStatusDisplay = {
  icon: string;
  label: string;
  color: string;
};

/**
 * Header/button accent for a coach card. Pool coaches have no badge at all —
 * `getStatusIcon` returns `undefined` for `pending` — so they fall back to
 * brand green rather than inheriting a missing `icon.color`.
 *
 * The status colours themselves come from the addon's `getStatusIcon`: green
 * for settled, copper for in progress. This app used to remap them here
 * because the addon paired teal against green, which is not separable for
 * red-green colour blindness; that is fixed at source now, so nothing needs
 * translating.
 */
export function coachCardColor(
  display: PartnershipStatusDisplay | undefined
): string {
  return display?.color ?? 'primary';
}

const STATUS_BADGE_BASE =
  'badge rounded-pill fw-semibold px-2 py-1 d-inline-flex align-items-center gap-1';

/**
 * Browse-card status chip. Same treatment for Chosen and Shortlisted so
 * the header colour (green vs copper) plus icon + label carry status, not
 * a white sticker vs a black one. `bg-body` is the card surface; 75%
 * opacity lets the header tint through in both themes.
 */
export function coachStatusBadgeClass(
  display: PartnershipStatusDisplay | undefined
): string {
  if (!display) {
    return STATUS_BADGE_BASE;
  }

  return `${STATUS_BADGE_BASE} bg-body text-body bg-opacity-75`;
}
